import React, { useState } from "react";
import { Button, Modal, ModalBody, Spinner } from "reactstrap";
import { Icon } from "../../../components/Component";

/**
 * IgChatModalResolve — modal resolve/history conversation Instagram.
 * Layout identik dengan ChatModalResolve.js (WA).
 * Product selection belum ada — placeholder sampai IG memiliki data produk.
 */
const IgChatModalResolve = ({
  isOpen,
  setIsOpen,
  chat,
  conversationStatus,
  onResolved,
  setMessages,
  roleFunctions = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const status = conversationStatus || "OPENED";

  // Identik dengan SolveIcon() di ChatModalResolve.js (WA)
  const SolveIcon = () => {
    if (status === "RESOLVED") return <i className="bi bi-check-circle modal-resolve-icon"></i>;
    if (status === "PENDING") return <i className="bi bi-exclamation-circle modal-resolve-icon pending-status"></i>;
    return <i className="bi bi-box-arrow-in-up modal-resolve-icon blue"></i>;
  };

  const handleSubmit = () => {
    if (!chat || status === "RESOLVED") return;

    setIsLoading(true);

    const formattedDate = new Date(Date.now()).toLocaleString("en-GB", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    const [datePart, timePart] = formattedDate.split(", ");

    setMessages?.((prev) => [
      ...prev,
      {
        message_id: "resolve_" + Date.now(),
        chat_id: chat.conversation_id,
        text: `Chat Session RESOLVED pada ${datePart} ${timePart}`,
        direction: "system",
        created_at: new Date().toISOString(),
      },
    ]);

    onResolved?.();
    setIsOpen(false);
    setIsLoading(false);
  };

  // Identik dengan guard di ChatModalResolve.js (WA)
  const canResolve =
    roleFunctions.includes("chat") &&
    status !== "RESOLVED" &&
    status !== "PENDING";

  return (
    <Modal
      isOpen={isOpen}
      backdrop="static"
      toggle={() => setIsOpen(false)}
      className="modal-dialog-centered"
      size="lg"
    >
      <ModalBody>
        {isLoading ? (
          <Spinner />
        ) : (
          <React.Fragment>
            {/* Close button — identik WA */}
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                setIsOpen(false);
              }}
              className="close"
            >
              <Icon name="cross-sm" />
            </a>

            {/* Status header — identik WA */}
            <div className="text-center">
              <span className="modal-resolve-title">Status: </span>
              <span className={`modal-resolve-title color-${status}`}>{status}</span>
              <div>
                <SolveIcon />
              </div>
            </div>

            {/* Product section — identik struktur WA, placeholder sampai produk IG tersedia */}
            {canResolve && (
              <div className="form-control-wrap">
                <div className="alert alert-info alert-icon mb-3" style={{ fontSize: 13 }}>
                  <Icon name="info" />
                  {" "}Fitur produk belum tersedia untuk Instagram Platform. Fitur ini akan segera hadir.
                </div>

                <Button
                  color="primary"
                  className="mt-2 mx-auto"
                  block
                  style={{ justifyContent: "center" }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              </div>
            )}
          </React.Fragment>
        )}
      </ModalBody>
    </Modal>
  );
};

export default IgChatModalResolve;
